import { useFlagOnaAIEnabled } from "@/hooks/use-flag";
import { parseAsBoolean, useQueryState } from "nuqs";
import type { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";

const useDefaultRedirect = () => {
    const { value: onaEnabled, loading: isLoadingOnaAIEnabled } = useFlagOnaAIEnabled();

    if (isLoadingOnaAIEnabled) {
        return null;
    }

    if (onaEnabled) {
        return "/ai";
    }

    return "/projects";
};

export const SlashRedirect: FC = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { state } = useLocation();
    const to = useDefaultRedirect();
    const [autoStart] = useQueryState("autostart", parseAsBoolean.withDefault(false));

    if (!to) {
        return null;
    }

    return (
        <Navigate
            to={{ pathname: to, hash: document.location.hash, search: document.location.search }}
            replace
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            state={{ ...state, showCreateModal: !!document.location.hash, autoStart }}
        />
    );
};
